export const ASSET_CONDITION_INDEX_HEADING = "Asset Average Condition Index";
// Resource segment reused by the shared log endpoints (`/{type}/logs`, `/{type}/logs/restore/{versionId}`).
export const ASSET_CONDITION_INDEX_LOG_TYPE = "asset-average-condition-indexes";
export const ASSET_CONDITION_INDEX_LIST_KEY = "asset_average_condition_indexes";
export const ASSET_CONDITION_INDEX_DECIMAL_LIMIT = 4;

export const GET_ASSET_CONDITION_INDEX_COLOR_REQUEST = "GET_ASSET_CONDITION_INDEX_COLOR_REQUEST";
export const GET_ASSET_CONDITION_INDEX_COLOR_SUCCESS = "GET_ASSET_CONDITION_INDEX_COLOR_SUCCESS";
export const GET_ASSET_CONDITION_INDEX_COLOR_FAILURE = "GET_ASSET_CONDITION_INDEX_COLOR_FAILURE";

export const ADD_ASSET_CONDITION_INDEX_COLOR_REQUEST = "ADD_ASSET_CONDITION_INDEX_COLOR_REQUEST";
export const ADD_ASSET_CONDITION_INDEX_COLOR_SUCCESS = "ADD_ASSET_CONDITION_INDEX_COLOR_SUCCESS";
export const ADD_ASSET_CONDITION_INDEX_COLOR_FAILURE = "ADD_ASSET_CONDITION_INDEX_COLOR_FAILURE";

export const UPDATE_ASSET_CONDITION_INDEX_COLOR_REQUEST = "UPDATE_ASSET_CONDITION_INDEX_COLOR_REQUEST";
export const UPDATE_ASSET_CONDITION_INDEX_COLOR_SUCCESS = "UPDATE_ASSET_CONDITION_INDEX_COLOR_SUCCESS";
export const UPDATE_ASSET_CONDITION_INDEX_COLOR_FAILURE = "UPDATE_ASSET_CONDITION_INDEX_COLOR_FAILURE";

export const DELETE_ASSET_CONDITION_INDEX_COLOR_REQUEST = "DELETE_ASSET_CONDITION_INDEX_COLOR_REQUEST";
export const DELETE_ASSET_CONDITION_INDEX_COLOR_SUCCESS = "DELETE_ASSET_CONDITION_INDEX_COLOR_SUCCESS";
export const DELETE_ASSET_CONDITION_INDEX_COLOR_FAILURE = "DELETE_ASSET_CONDITION_INDEX_COLOR_FAILURE";
